module.exports = __webpack_public_path__ + "3af3fff8198e28584454fa12a6a2a6ff.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/charts/regeneron_pharmaceuticals_2021_chart.png
// module id = 1724
// module chunks = 0